__webpack_require__.p = "https://static.serealshort.com/sparkshort/";